import { Button } from "@/components/ui/Button";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/Dialog";
import { Check, Copy } from "lucide-react";
import { useState } from "react";

/** The dataset's methods section, written for a publication, with a copy button. */
export const MethodsDialog = ({ text, open, onOpenChange }: { text: string; open: boolean; onOpenChange: (open: boolean) => void }) => {
  const [copied, setCopied] = useState(false);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl p-6">
        <DialogTitle className="pr-6 text-base">Methods</DialogTitle>
        <DialogDescription className="font-ui text-xs text-zinc-500">
          Written from how this dataset was built. Check it against your study before you publish it.
        </DialogDescription>
        <div className="max-h-[65vh] space-y-3 overflow-y-auto text-[14px] leading-relaxed text-zinc-800">
          {text.split(/\n\s*\n/).map((paragraph, i) => (
            <p key={i}>{paragraph.trim()}</p>
          ))}
        </div>
        <div className="flex justify-end">
          <Button
            size="sm"
            variant="outline"
            onClick={() => {
              void navigator.clipboard.writeText(text).then(() => setCopied(true));
            }}
          >
            {copied ? <Check className="h-4 w-4" aria-hidden /> : <Copy className="h-4 w-4" aria-hidden />}
            {copied ? "Copied" : "Copy"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
